export const LOCAL_STORAGE_USER_KEY = 'x-otterbrick-user-key';
export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'x-otterbrick-access-token';
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'x-otterbrick-refresh-token';
export const LOCAL_STORAGE_STUDENT_KEY = 'x-otterbrick-student-key';
export const ACCESS_TOKEN_HEADER = 'x-otterbrick-token';
export const NON_AUTHENTICATION_ENDPOINTS = ['/signin', '/signup', '/api/v1/version'];
